import { cn } from "@/shared/lib/utils";
import { type ComponentPropsWithoutRef, forwardRef } from "react";

/**
 * Sjednocený zaškrtávací prvek nad nativním `<input type="checkbox">`.
 * Záměrně nativní (ne Radix), aby fungoval přímo s react-hook-form `register()`
 * a držel jednotný vzhled napříč formuláři (dřív byly checkboxy různě velké).
 */
export const Checkbox = forwardRef<
  HTMLInputElement,
  Omit<ComponentPropsWithoutRef<"input">, "type">
>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    type="checkbox"
    className={cn(
      "h-4 w-4 shrink-0 cursor-pointer rounded border border-input accent-primary",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  />
));
Checkbox.displayName = "Checkbox";
